export const environment = {
  production: true,

  issuer: 'https://sts-acc.inforius.be',
  postLogoutRedirectUri: 'https://icourrier2nd-test.myinforius.be',
  redirectUri: 'https://icourrier2nd-test.myinforius.be/callback',
  clientId: 'icour_e1_2nd_test',
  oidc: true,
  userinfoEndpoint: 'https://sts-acc.inforius.be/connect/userinfo',
  useSilentRefresh: true,
  scope:
    'icour.e1_2nd_test_f icont.e1_2nd_test_icour_f itemplate.api openid profile email iadm.e1_2nd_test_f icont.e1_2nd_test_iadm_f iaddress.api iscan.api_e2 offline_access',
  showDebugInformation: false,
  silentRefreshRedirectUri: 'https://icourrier2nd-test.myinforius.be/silent-renew.html',
  responseType: 'code',
  requireHttps: true,
  baseUrl: 'https://icourrier2nd-test.myinforius.be',
  apiGatewayBaseUrl: 'https://icourrier2ndapigw-test.myinforius.be',

  apiContactiCourrierV1BaseUrl: 'https://icourrier2ndapigw-test.myinforius.be/iContactsCourriers/api/v1',
  apiContactiCourrierV2BaseUrl: 'https://icourrier2ndapigw-test.myinforius.be/iContactsCourriers/api/v2',
  apiContactAdminBaseUrl: 'https://iadm2ndapigw-test.myinforius.be/iContactsAdm/api/v1',
  apiICourrierBaseUrl: 'https://icourrier2ndapigw-test.myinforius.be/iCourriers/api/v2',
  apiICourrierJobsBaseUrl: 'https://icourrier2ndapigw-test.myinforius.be/iCourriersJobs/api/v1',
  apiICourrierWorkflowsBaseUrl: 'https://icourrier2ndapigw-test.myinforius.be/iCourriersWorkflows/api/v1',
  apiScanPath: '',
  apiScanRoot: 'https://api-acc-iscan.myinforius.be',
  baseUrlDocumentEditor: 'https://iadm2ndapigw-test.myinforius.be/iTemplate/api/v2/',
  baseUrlSign: 'https://fake-isign.be/eSign/api/v1/sign',
  iDelibeUrl: 'https://idelibe2nd-test.myinforius.be',
  iDelibeApi: 'https://idelibe2ndapigw-test.myinforius.be/iDelibe',
  frontIAdminUrl: 'https://iadm2nd-test.myinforius.be',
  iAdminApiBaseURL: 'https://iadm2ndapigw-test.myinforius.be/iAdm/api/v1',
  iAddressBaseURL: 'https://iaddressapi-acc.azurewebsites.net/api/v1',
  showDocExportBtn: false,
  enableSpellCheck: false,
  enableLogConsole: true,
  versionNumber: '6.2.0',
  environmentTitle: '',
  apiRoots: [
    'https://icourrier2nd-test.myinforius.be',
    'https://icourrier2ndapigw-test.myinforius.be',
    'https://iadm2ndapigw-test.myinforius.be',
    'https://api-acc-iscan.myinforius.be',
    'https://fake-isign.be/eSign/api/v1/sign',
    'https://idelibe2nd-test.myinforius.be',
    'https://idelibe2ndapigw-test.myinforius.be/iDelibe',
    'https://iadm2nd-test.myinforius.be',
    'https://iaddressapi-acc.azurewebsites.net/api/v1',
  ],
};
